module.exports = __webpack_public_path__ + "static/media/hero-clouds-reverse.021ec1fc.jpg";